export default __webpack_public_path__ + "static/media/icons-currency-nugget-sml.69e1faed.png";